var render = function render(){
  var _vm$error, _vm$error$validationM;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "mb-4",
    attrs: {
      "src": require("@/assets/forgot-password/lock-icon.svg")
    }
  }), _c('p', {
    staticClass: "reset-password-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('reset-password.form.header')) + " ")]), _c('p', {
    staticClass: "mb-5"
  }, [_vm._v(" " + _vm._s(_vm.$t('reset-password.form.information')) + " ")])]), _vm.error && _vm.error.key ? _c('b-alert', {
    staticClass: "mt-4",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.error.key)) + " ")]) : _vm._e(), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', [_c('form-input', {
    attrs: {
      "id": "reset-password-password",
      "label": _vm.$t('reset-password.form.password'),
      "required": "",
      "state": _vm.getState('password'),
      "validation-messages": (_vm$error = _vm.error) === null || _vm$error === void 0 ? void 0 : (_vm$error$validationM = _vm$error.validationMessages) === null || _vm$error$validationM === void 0 ? void 0 : _vm$error$validationM.password,
      "type": "password"
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.password.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('reset-password.form.password')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.password.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('reset-password.form.password'),
          max: _vm.$v.formData.password.$params.maxLength.max
        })) + " ")]) : _vm._e(), !_vm.$v.formData.password.minLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.min-length', {
          field: _vm.$t('reset-password.form.password'),
          min: _vm.$v.formData.password.$params.minLength.min
        })) + " ")]) : _vm._e(), !_vm.$v.formData.password.uppercase ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.password.uppercase')) + " ")]) : _vm._e(), !_vm.$v.formData.password.digit ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.password.digit')) + " ")]) : _vm._e(), !_vm.$v.formData.password.special ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.password.special')) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.formData.password,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "password", $$v);
      },
      expression: "formData.password"
    }
  })], 1)], 1), _c('b-row', [_c('b-col', [_c('form-input', {
    attrs: {
      "id": "reset-password-password-again",
      "label": _vm.$t('reset-password.form.password-again'),
      "required": "",
      "state": _vm.getState('passwordAgain'),
      "type": "password"
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.passwordAgain.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('reset-password.form.password-again')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.passwordAgain.sameAs ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.password.same-as')) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.formData.passwordAgain,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "passwordAgain", $$v);
      },
      expression: "formData.passwordAgain"
    }
  })], 1)], 1), _c('b-row', [_c('b-col', [_c('b-button', {
    staticClass: "w-100",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('reset-password.button.submit')) + " ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }